import {
  StructuredTableColumn,
  TagValueStructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';

export default function isTagValueStructuredTableColumn(
  column: StructuredTableColumn
): column is TagValueStructuredTableColumn {
  return column.columnType === TableColumnType.TAG_VALUE;
}
